export default {
    format_sd_card_title: "Formatear la tarjeta SD",
    format_sd_card_command_sent_to_the_device: "Comando enviado al dispositivo",
    format_sd_card_error_sending_the_command: "Error al enviar el comando",
    format_sd_card_label: "¿Desea formatear la tarjeta SD de este dispositivo?",
    format_sd_card_format_sd_card: "Formatear la tarjeta SD",
}